<form [formGroup]="form">
  <div class="row mb-3">
    <!-- filter / status -->
    <div class="col-auto align-self-center">
      <lds-choice-group
        identifier="{{ identifier }}-contactTypes"
        name="{{ identifier }}-contactTypes"
        [options]="contactType | stringArray | choiceOption"
        [selected]="selectedContactType"
        (getChange)="onContactTypeFilterChange($event)">
      </lds-choice-group>
    </div>

    <!-- search -->
    <div class="col align-self-center contact-filters__search-wrap">
      <lds-input
        formControlName="search"
        identifier="{{ identifier }}-search"
        name="search"
        placeholder="search contacts"
        iconPrefix="search">
      </lds-input>
    </div>

    <div class="col-auto align-self-center">
      <lds-select
        formControlName="tagFilter"
        identifier="{{ identifier }}-tagFilter"
        name="tagFilter"
        placeholder="All Tags"
        [options]="tagOptions | ldsSelectOption"
        [config]="{
          valueProperty: 'value',
          labelProperty: 'label'
        }"
        class="contact-filters__tag-select">
      </lds-select>
    </div>

    <ng-container *ngIf="includeAccessible">
      <div class="col-12 col-md-6 col-lg-2 align-self-center contact-filters__owned-by-wrap">
        <app-user-dropdown
          [users]="users"
          [selectedUserId]="selectedUserId"
          [placeholder]="'All'"
          [includeAllOption]="true"
          [label]="'Owned By'"
          [identifier]="identifier + '-ownedBy'"
          (userSelected)="onUserSelected($event)">
        </app-user-dropdown>
      </div>
    </ng-container>

    <!-- sort order -->
    <div class="col-auto pl-0 align-self-center">
      <sparkplus-dropdown
        [items]="sortItems"
        [isOpen]="sortOptionOpen"
        (onSelection)="onSortSelected($event)"
        (onClose)="closeSortMenu()">
        <dropdown-toggle>
          <lds-icon-button
            icon="sort"
            appearance="default"
            (click)="toggleSortMenu()">
          </lds-icon-button>
        </dropdown-toggle>
      </sparkplus-dropdown>
    </div>
  </div>
</form>
